/* eslint-disable func-names */
/* eslint-disable no-undef */
/* eslint linebreak-style: ["error", "windows"] */
/**
 * Parse data attrs
 * @param   {object/string} opts
 * @todo - https://ba.northernbadger.co.uk/ba.html#options
 */
export default (el, args) => {
  const defaults = {
    element: el,
    animationTime: 300,
  };

  const options = Object.assign({}, defaults, args);

  const { location: { hash } } = window;

  if (hash) {
    setTimeout(() => $(hash).children('.schema-faq-question').trigger('click'), 500);
  }

  // AM2 Accordion
  jQuery(options.element).on('click', '.schema-faq-question', function () {
    var currentElHeight = jQuery( this ).outerHeight();
    if ($(this).hasClass('schema-faq-question--current')) {
      $(this).removeClass('schema-faq-question--current')
        .next('.schema-faq-answer')
        .stop()
        .slideUp(options.animationTime)
    } else {
      const currentAccordionPanel = jQuery(options.element).find('.schema-faq-question--current');
      if (currentAccordionPanel.length > 0) {
        currentAccordionPanel.removeClass('schema-faq-question--current')
          .next('.schema-faq-answer')
          .stop()
          .slideUp(options.animationTime)
      }
      $(this).addClass('schema-faq-question--current')
        .next('.schema-faq-answer')
        .stop()
        .slideDown(options.animationTime, () => {
          const $question = $(this).parent();
          history.pushState({}, '', `#${$question.attr('id')}`);
          //const top = $question.offset().top - $('header.header').height() - currentElHeight;
          //$('html,body').animate({ scrollTop: top }, 300);
        });
    }
  });
};
